import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.GetGlobalSearchResultsPresenter'

export default defineMessages({
  confirmationTitle: {
    id: `${scope}.confirmationTitle`,
    defaultMessage: "Procurify's guided intake can help with next steps",
  },
  confirmationAction: {
    id: `${scope}.confirmationAction`,
    defaultMessage: 'Help me build a request',
  },
})
